import { Routes, Route } from "react-router-dom";
import LoginComponent from "./components/core/login-component/LoginComponent";
import RecoveryComponent from "./components/core/recovery-component/RecoveryComponent";
import TermsComponent from "./components/core/terms-component/TermsComponent";
import DashboardComponent from "./components/dash-component/DashboardComponent";
import InvoiceComponent from "./components/invoice-component/InvoiceComponent";
import WelcomeComponent from "./components/welcome-component/WelcomeComponent";
import ErrorComponent from "./components/core/error-component/ErrorComponent";
import CacioComponent from "./components/cacio-component/CacioComponent";
import "./AccessoItaliano.css";
import PrivacyPolicyComponent from "./components/core/privacy-component/PrivacyPolicyComponent";
import CookieComponent from "./components/core/cookie-component/CookieComponent";
import InvoiceFragment from "./components/dash-component/fragments/InvoiceFragment";
import InventoryComponent from "./components/inventory-component/InventoryComponent";
import SettingsComponent from "./components/settings-component/SettingsComponent";
import AlertCard from "./components/dash-component/fragments/AlertCard";
import { SessionProvider } from "./components/core/SessionProvider";

export default function AccessoItalianoApp() {

  return (
    <div id="home" className="accesso-italiano-app">
      <Routes>
        <Route path="/" element={<WelcomeComponent />} />
        <Route path="/cacio-gang/:folder/:objectKey" element={<CacioComponent />} />
        <Route path="/login" element={<LoginComponent />} />
        <Route path="/error" element={<ErrorComponent />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyComponent />} />
        <Route path="/cookie-policy" element={<CookieComponent />} />
        <Route path="/terms-and-conditions" element={<TermsComponent />} />
        <Route path="/recovery" element={<RecoveryComponent />} />
        <Route
          path="/dashboard"
          element={
            <SessionProvider>
              <DashboardComponent />
            </SessionProvider>
          }
        >
          {/* Contenuto di default della dashboard */}
          <Route
            index
            element={
              <div className="dash-component__content">
                <div className="dash-component__content-left">
                  <InvoiceFragment
                    invoice={{ name: "Fattura #1234", date: "2025-08-13", sender: "Mario Rossi" }}
                    title="Last Loaded"
                  />
                </div>
                <div className="dash-component__content-right">
                  <AlertCard
                    alert={{ client: "Luigi Bianchi", product: "Prodotto XYZ", code: "ALERT-001" }}
                  />
                </div>
              </div>
            }
          />

          {/* Sezione Fatture */}
          <Route path="invoices" element={<InvoiceComponent />} />
          <Route path="inventory" element={<InventoryComponent />} />
          <Route path="settings" element={<SettingsComponent />} />

          {/* Qui puoi aggiungere altre rotte figlie, es: inventario, impostazioni */}
        </Route>

        <Route path="*" element={<WelcomeComponent />} />
      </Routes>
    </div>
  );
}
